import { Link } from "react-router-dom";
export default function Footer(){
    return(
        <footer className='footer'>
            <div className="footer__column footer__column-first">
                <nav>
                    <ul className="menu">
                        <Link to="/" className="menu__link"><li>Cookies</li></Link>
                        <Link to="/" className="menu__link"><li>Privacy Policy</li></Link>
                        <Link to="/" className="menu__link"><li>Refund Policy</li></Link>
                        <Link to="/" className="menu__link"><li>Shipping Policy</li></Link>
                        <Link to="/" className="menu__link"><li>Terms Of Service</li></Link>
                        <Link to="/" className="menu__link"><li>Acceptable Use Policy</li></Link>
                        <Link to="/" className="menu__link"><li>Personal information</li></Link>
                    </ul>
                </nav>
            </div>
            <div className=" footer__column footer__column-second"></div>
            <div className=" footer__column footer__column-third">
                <div className="footer__logo">
                <svg id="arcadia-small" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 56.2 11.1">
                    <g id="c">
                        <g id="d">
                            <path className="e"
                                  d="m10.8,10.9c-1.4-1.2-3.2-1.8-5-1.8s-2.6.3-3.7.9l-.6-1.1c1.3-.7,2.8-1.1,4.3-1.1,2.2,0,4.2.8,5.8,2.1l-.8.9Z"/>
                            <path className="e"
                                  d="m14.1,5.4c.3-1.3,1.1-2.1,2.5-2.1s.4,0,.5,0v.7c-.2,0-.4,0-.6,0-1.7,0-2.4,1.8-2.4,4.1v2.9h-.7V3.4h.7v2Z"/>
                            <path className="e"
                                  d="m21.7,3.3c.6,0,1.6.2,2.6.8l-.3.5c-.9-.6-1.8-.7-2.2-.7-2.2,0-3.5,1.4-3.5,3.3,0,1.9,1.3,3.3,3.5,3.3s1.4-.1,2.2-.7l.3.5c-1,.7-2,.8-2.6.8-2.7,0-4.2-1.7-4.2-3.9,0-2.2,1.5-3.9,4.2-3.9Z"/>
                            <path className="e"
                                  d="m32.5,9c-.5,1.2-1.8,2.1-3.2,2.1-2.3,0-3.9-1.7-3.9-3.9s1.5-3.9,3.9-3.9,2.7.8,3.2,2v-1.9h.7v7.5h-.7v-1.9Zm0-1.9c0-1.8-1.3-3.3-3.2-3.3s-3.2,1.5-3.2,3.3,1.3,3.3,3.2,3.3,3.2-1.5,3.2-3.3Z"/>
                            <path className="e"
                                  d="m42.3,9c-.5,1.2-1.8,2.1-3.2,2.1-2.3,0-3.9-1.7-3.9-3.9s1.5-3.9,3.9-3.9,2.7.8,3.2,2V0h.7v10.9h-.7v-1.9Zm0-1.9c0-1.8-1.3-3.3-3.2-3.3s-3.2,1.5-3.2,3.3,1.3,3.3,3.2,3.3,3.2-1.5,3.2-3.3Z"/>
                            <path className="e"
                                  d="m45.9.2c.3,0,.5.2.5.6s-.2.6-.5.6-.5-.2-.5-.6.2-.6.5-.6Zm.4,10.7h-.7V3.4h.7v7.5Z"/>
                            <path className="e"
                                  d="m55.5,9c-.5,1.2-1.8,2.1-3.2,2.1-2.3,0-3.9-1.7-3.9-3.9s1.5-3.9,3.9-3.9,2.7.8,3.2,2v-1.9h.7v7.5h-.7v-1.9Zm0-1.9c0-1.8-1.3-3.3-3.2-3.3s-3.2,1.5-3.2,3.3,1.3,3.3,3.2,3.3,3.2-1.5,3.2-3.3Z"/>
                            <polygon className="e"
                                     points="1.5 10.9 6.4 3.2 10.9 10.9 12.3 10.9 6.5 .9 0 10.9 1.5 10.9"/>
                        </g>
                    </g>
                </svg>
                </div>
                <div className="footer__contacts">
                    <p>arcadiacyclingclub@gmail.com</p>
                </div>
            </div>
            <p className="footer__copyright">Copyright © 2024</p>
        </footer>
    );
};